import { render, staticRenderFns } from "./WhatWeOffer.vue?vue&type=template&id=99b98aa0&scoped=true&"
var script = {}
import style0 from "./WhatWeOffer.vue?vue&type=style&index=0&id=99b98aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b98aa0",
  null
  
)

export default component.exports